import {useSnackbar} from 'notistack'
import {useRef, useState} from 'react'
import {FacialListDTO} from 'src/common/models/facial-recognition/FacialListDTO'
import api from 'src/services/api'
import {Page} from 'src/types'

type FacialListItemsProps = {
  listId: number
  filter: string
  page: Page
}

function useFacialListItems(props: FacialListItemsProps) {
  const {filter: faceName, listId, page} = props
  const [listItems, setListItems] = useState<FacialListDTO[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [totalItems, setTotalItems] = useState(0)
  const blockRequests = useRef(false)
  const {enqueueSnackbar} = useSnackbar()

  async function getFaceListItems() {
    if (blockRequests.current) return
    blockRequests.current = true
    setIsLoading(true)
    try {
      const res = await api.facialRecognition.getFacialList({
        page: page.page,
        pageSize: page.pageSize,
        search: {faceName},
        filter: {listIds: [listId]},
        includes: ['faceImages;'],
      })
      setListItems(res.data.data.entities)
      setTotalItems(res.data.data.totalPages ?? 0)
    } catch (err) {
      enqueueSnackbar('Erro ao buscar listas de faces', {variant: 'error'})
    } finally {
      blockRequests.current = false
      setIsLoading(false)
    }
  }

  return {listItems, isLoading, totalItems, getFaceListItems}
}

export default useFacialListItems
